import _get from 'hs-lodash/get';
import { useCallback, useContext, useEffect, useState } from 'react';
import { ACTIONS, SCREENS } from '../../constants/Tracking';
import { ContactsPropsContext } from '../../contexts/contacts/PropsContext';
import { ContactsListWrapper } from '../../styles/contacts';
import { buildName } from '../../utils/contacts';
import ContactListRow from './ContactListRow';
import { jsx as _jsx } from "react/jsx-runtime";
function ContactList({
  contacts,
  onClickAssociate,
  setPopupToUnmap,
  showProfileLink,
  openPreviewModal
}) {
  const {
    usageTracker
  } = useContext(ContactsPropsContext);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const resizeHandler = useCallback(() => {
    setWindowWidth(window.innerWidth);
  }, []);
  useEffect(() => {
    window.addEventListener('resize', resizeHandler);
    return () => {
      window.removeEventListener('resize', resizeHandler);
    };
  }, [resizeHandler]);
  return /*#__PURE__*/_jsx(ContactsListWrapper, {
    children: contacts.map(contact => {
      const participantId = _get(contact, 'participantId');
      const contactId = _get(contact, 'contact.id');
      const email = _get(contact, 'contact.email') || _get(contact, 'email');
      const participantName = buildName(contact);
      const hubspotContactName = buildName(_get(contact, 'contact') || {});
      const openPopupToUnmap = () => {
        setPopupToUnmap({
          hubspotContactName,
          participantName,
          participantId,
          contactId
        });
        usageTracker.trackInteraction(Object.assign({
          screen: SCREENS.participants
        }, ACTIONS.participants.clickUnmap));
      };
      return /*#__PURE__*/_jsx(ContactListRow, {
        email: email,
        participantName: participantName,
        contactId: contactId,
        participantId: participantId,
        onClickAssociate: () => {
          onClickAssociate({
            participantId,
            email,
            name: participantName
          });
        },
        openPopupToUnmap: openPopupToUnmap,
        showProfileLink: showProfileLink,
        openPreviewModal: openPreviewModal,
        isAutoMapped: contact.isAutoMapped || false,
        windowWidth: windowWidth
      }, participantId);
    })
  });
}
export default ContactList;